/** @type {Set<string>} */
const expandedKeys = new Set();

/**
 * @param {string} key
 * @returns {boolean}
 */
export function isPillboxExpanded(key) {
  return expandedKeys.has(key);
}

/**
 * @param {string} key
 * @param {boolean} expanded
 */
export function setPillboxExpanded(key, expanded) {
  if (expanded) {
    expandedKeys.add(key);
  } else {
    expandedKeys.delete(key);
  }
}

/**
 * Builds a stable key for pillbox expand state in grid cells.
 * @param {string} scope - Column scope, e.g. "catalogs"
 * @param {string|number|undefined} rowId - Licensing job id
 * @returns {string|null}
 */
export function getPillboxExpansionKey(scope, rowId) {
  if (!scope || rowId == null || rowId === "") {
    return null;
  }
  return `licensingJob-${rowId}-${scope}`;
}
